import { problemContent } from "@/app/content/landingContent";

export function ProblemSection() {
  return (
    <section
      id="problem"
      className="py-20 md:py-24 px-6 bg-gray-50"
      aria-labelledby="problem-heading"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 max-w-3xl">
          <h2
            id="problem-heading"
            className="text-[clamp(1.875rem,4vw,3rem)] text-slate-900 mb-6 tracking-tight font-bold"
          >
            {problemContent.heading}
          </h2>
          <p className="text-[clamp(1.125rem,2vw,1.25rem)] text-slate-600 leading-relaxed max-w-prose">
            {problemContent.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl">
          {problemContent.points.map((point) => (
            <article
              key={point.title}
              className="group bg-white rounded-2xl p-8 shadow-[0_2px_8px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.1)] transition-shadow duration-300"
            >
              <div className="w-7 h-0.5 bg-[#004f4f] mb-6" aria-hidden="true" />

              <h3 className="text-lg md:text-xl text-slate-900 mb-3 font-semibold leading-snug group-hover:text-[#004f4f] transition-colors duration-200">
                {point.title}
              </h3>

              <p className="text-slate-600 leading-relaxed text-base">
                {point.text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
